import { type FirebaseApp, getApps, initializeApp } from "firebase/app";
import { type Auth, connectAuthEmulator, getAuth } from "firebase/auth";
import type { ClientConfig } from "@/generated/backend/v1/config";

/** Firebase is initialized once, from GET /api/config (never from build-time values). */
let app: FirebaseApp | null = null;
let auth: Auth | null = null;

export function initFirebase(config: ClientConfig): Auth {
  if (auth) return auth;
  const fb = config.firebase;
  if (!fb?.apiKey) {
    throw new Error("The backend's /api/config has no Firebase configuration.");
  }
  app =
    getApps()[0] ??
    initializeApp({
      apiKey: fb.apiKey,
      authDomain: fb.authDomain,
      projectId: fb.projectId,
      storageBucket: fb.storageBucket,
      messagingSenderId: fb.messagingSenderId,
      appId: fb.appId,
      measurementId: fb.measurementId || undefined,
    });
  auth = getAuth(app);
  if (config.authEmulatorHost) {
    const host = config.authEmulatorHost.startsWith("http")
      ? config.authEmulatorHost
      : `http://${config.authEmulatorHost}`;
    connectAuthEmulator(auth, host, { disableWarnings: true });
  }
  return auth;
}

export function getFirebaseAuth(): Auth | null {
  return auth;
}
